import {
  getSessionAndCorrelationID,
  storeBookingApiData,
} from "../../../../common/components/Helper/Helper";
import {
  AppConstants,
  IS_PRICING_AVAILABLE,
  SESSION_QUOTE_ESTIMATE,
  SESSION_CORRELATIONID,
  SESSION_FILES,
  SESSION_FILES_UPLOAD,
  SESSION_FILEURLS,
  SESSION_FORMVALUES,
  SESSION_NON_PRICEABLE_QUOTE_ESTIMATE,
  SESSION_PRIMARYSOURCE,
  SESSION_SELFSTORAGE,
  sharedStateKeys,
  conceptCodes,
} from "../../../../constants/constant";
import { bookingApiCall } from "../../../../service/apiService";
import { sessionStorageUtils } from "../../../../utility/utility";
import BookingPayload from "./BookingPayload";
import {
  FormValues,
  SchedulerConfig,
} from "../../../../Interface/scheduler/form";
import {
  LeadApiCallHandler,
  getBookingAPIKey,
  isJUKPaymentStep,
  push5UMB17Text,
  redirectToConfirmation,
} from "./LeadOrchestrationApiCallHandler";
import isInboundFromNbly from "../../../../utility/checkInBoundFromNbly";
import getChildForCommercialInputFlow from "../../../../utility/getChildForCommercialInputFlow";

const storeSesstionData = (
  localFormValues: FormValues,
  correlationID: string,
  state,
) => {
  sessionStorageUtils.setItem(SESSION_FORMVALUES, localFormValues);
  sessionStorageUtils.setItem(SESSION_CORRELATIONID, correlationID);
  if (state[sharedStateKeys.PRICE_QUOTE_ESTIMATION_OBJECT]) {
    sessionStorageUtils.setItem(
      SESSION_QUOTE_ESTIMATE,
      state[sharedStateKeys.PRICE_QUOTE_ESTIMATION_OBJECT],
    );
  }
  if (state[sharedStateKeys.NON_PRICABLE_QUOTE_ESTIMATION_OBJECT]) {
    sessionStorageUtils.setItem(
      SESSION_NON_PRICEABLE_QUOTE_ESTIMATE,
      state[sharedStateKeys.NON_PRICABLE_QUOTE_ESTIMATION_OBJECT],
    );
  }
  if (state[sharedStateKeys.IS_PRICING_AVAILABLE]) {
    sessionStorageUtils.setItem(IS_PRICING_AVAILABLE, "true");
  } else {
    sessionStorageUtils.setItem(IS_PRICING_AVAILABLE, "false");
  }
};

const clearSessionData = () => {
  sessionStorageUtils.removeItem(SESSION_FILEURLS);
  sessionStorageUtils.removeItem(SESSION_PRIMARYSOURCE);
  sessionStorageUtils.removeItem(SESSION_SELFSTORAGE);
  sessionStorageUtils.removeItem(SESSION_FILES);
  sessionStorageUtils.removeItem(SESSION_FILES_UPLOAD);
  sessionStorageUtils.removeItem(SESSION_CORRELATIONID);
  window.history.replaceState({}, "", window.location.href);
};

const enumStepTypes = {
  "contact-us-section": "contactInformation",
  "request-time-section": "Scheduler",
  "how-we-can-reach": "serviceInformation",
};

export const BookingApiCallHandler = async (
  formConfig: SchedulerConfig,
  formValues: FormValues,
  setTechnicalModalOpen: (modalOpen: boolean) => void,
  state = {},
  pauseLead = false,
  {
    bookingWrapper = false,
    current,
    total,
    upSellEnabled = false,
  }: {
    bookingWrapper?: boolean;
    current?: number;
    total?: number;
    upSellEnabled?: boolean;
  } = {},
) => {
  try {
    const localFormValues = JSON.parse(JSON.stringify(formValues));
    const brandPauseLeadTimer = formValues.pauseLeadTimer;
    const schedulerTimer = formConfig.steps[current]?.pauseLeadTimer;
    const timer = Number(schedulerTimer) || Number(brandPauseLeadTimer) || "";

    if (
      localFormValues[AppConstants.VEHICLE_REPAIR_ID]?.includes(
        AppConstants.OTHER_TYPE,
      ) ||
      localFormValues[AppConstants.VEHICLE_REPAIR_ID]?.includes(
        AppConstants.OTHER_TYPES,
      )
    ) {
      localFormValues[AppConstants.VEHICLE_REPAIR_ID] = localFormValues[
        AppConstants.VEHICLE_REPAIR_ID
      ].map((value: string) => {
        if (
          value === AppConstants.OTHER_TYPE ||
          value === AppConstants.OTHER_TYPES
        ) {
          return (
            localFormValues[AppConstants.OTHER_TYPE] ||
            localFormValues[AppConstants.OTHER_TYPES]
          );
        }
        return value;
      });
    }
    localFormValues.bookingWrapper = JSON.stringify(bookingWrapper);
    const { correlationID, sessionID } = getSessionAndCorrelationID();
    const payload = BookingPayload(
      localFormValues,
      formConfig,
      pauseLead,
      correlationID,
      state,
      current,
      push5UMB17Text(bookingWrapper, current, total, formConfig, formValues),
    );
    let url = `${LeadApiCallHandler(bookingWrapper, current, total, upSellEnabled, formConfig, formValues)}?apikey=${getBookingAPIKey(String(bookingWrapper))}`;
    if (sessionID && correlationID) {
      url += `&correlationId=${correlationID}&sessionId=${sessionID}`;
    }
    if (bookingWrapper) {
      payload.stepType =
        enumStepTypes[formConfig.steps[current].steptype] ||
        formConfig.steps[current].steptype;
    }
    if (bookingWrapper && timer) {
      payload.pauseLeadTimer = timer;
    }
    sessionStorage.removeItem("bookingLeadSent");
    const redirectionUrl = formConfig.redirectionPageUrl ?? "/confirmation";
    const response = await bookingApiCall(url, payload);
    storeBookingApiData(payload, response);

    try {
      sessionStorage.setItem("confirmation-url", redirectionUrl);
    } catch (error) {
      console.error("Error setting confirmation URL:", error);
    }
    let bookLead = false;
    if (formValues.servicetype === AppConstants.COMMERCIAL_TEXT) {
      const isCommercialmorethanone =
        getChildForCommercialInputFlow(formConfig, current, formValues)?.[
          "modifierflow"
        ] === true;
      bookLead =
        Number.parseInt(formValues.commercialInputFlow) > 1 &&
        isCommercialmorethanone;
    }

    if (response) {
      storeSesstionData(localFormValues, correlationID, state);
      if (
        current === total - 1 ||
        isJUKPaymentStep(formConfig, current) ||
        bookLead ||
        (formConfig?.conceptCode === conceptCodes.JUK_CONCEPT_CODE &&
          redirectToConfirmation(formValues, formConfig, current))
      ) {
        clearSessionData();
        window.onbeforeunload = null;
        if (isInboundFromNbly()) {
          const baseUrl = globalThis.location.origin;
          const URL = globalThis.location.origin + globalThis.location.pathname;
          const isCa = URL.includes("com/ca");
          const confirmationPath = isCa
            ? `/ca/${redirectionUrl}`
            : redirectionUrl;
          globalThis.location.replace(
            `${baseUrl}${confirmationPath}?leadconcept=${formConfig.conceptCode}`,
          );
          return;
        }
        globalThis.location.replace(redirectionUrl);
      }
      return response;
    } else if (current === total - 1) {
      setTechnicalModalOpen(true);
    }
  } catch (error) {
    console.error("Error booking:", error);
    setTechnicalModalOpen(true);
  }
};
